import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CompanyMessagesModel } from '../companies/models/company.messages';
import { TableService }         from '../table/table.service';
import { VendorModel }          from './models/vendor';
import { VendorsComponent }     from './vendors.component';
import { VendorsService }       from './vendors.service';

export const VendorsStates : Array<NgHybridStateDeclaration> = [
  {
    component: VendorsComponent,
    name     : 'app.vendors',
    resolve  : [
      {
        deps     : [ VendorsService ],
        resolveFn: ( vendorsService : VendorsService ) : Promise<CompanyMessagesModel> => vendorsService.getDefaultMessages(),
        token    : 'companyMessages'
      },
      {
        deps     : [ TableService, VendorsService ],
        resolveFn: ( tableService : TableService, vendorsService : VendorsService ) : Promise<Array<VendorModel>> => {
          const cache = tableService.getCacheForTable(vendorsService.tableCacheKey);

          return vendorsService.get({
              direction: cache.sorting.direction || 'asc',
              field    : cache.sorting.field     || 'company_name',
              offset   : 0,
              pageSize : cache.paging.pageSize   || 10
            }, {
              archivedOnly: !!cache.filtering.archivedOnly,
              value       : cache.filtering.value || ''
            });
        },
        token: 'vendors'
      }
    ],
    url: '/vendors'
  }
];
